<template>
  <b-container fluid
               class="p-0">
    <div id="sidebar"
         :style="{ width: sidebarWidth }">
      <chatter-sidebar v-show="showSidebar"/>
    </div>
    <div class="chatter-main-view"
         :style="{ width: mainWidth, marginLeft: sidebarWidth }"
         style="background: #f6f6fa;"
         :class="{ 'full' : !showSidebar }">
      <chatter-top-bar project="CHT"/>
      <router-view class="chatter-router-view"
                   style="background: #f6f6fa;"/>
    </div>
  </b-container>
</template>

<script>
import ChatterTopBar from '@/components/ChatterTopBar.vue'
import ChatterSidebar from '@/components/chatter/ChatterSideBar.vue'

export default {
  components: {
    ChatterTopBar,
    ChatterSidebar,
  },
  computed: {
    sidebarWidth() {
      return (this.showSidebar ? 16.666 : 0) + '%';
    },
    mainWidth() {
      return (this.showSidebar ? 83.334 : 100) + '%';
    },
  },
  data() {
    return {
      showSidebar: true,
    };
  },
  methods: {
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
  },
}
</script>

<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

.chatter-main-view {
    transition: all ease-in-out .3s;
    min-height: 100vh;
}

.chatter-router-view {
    padding: 6.666rem 3.125vw 0.5vw !important;
}

#sidebar {
    position: fixed;
    height: 100vh;
    overflow-y: auto;
    background-color: #2E2E38;
}

#sidebar::-webkit-scrollbar {
    display: none;
}
</style>